import { createSlice } from "@reduxjs/toolkit";

const medicationRequestSlice = createSlice({
    name: "medicationRequests",
    initialState: {},
    reducers: {
        registerMedicationRequest: (state, action) => {
            const medRequest = action.payload;
            if (!medRequest?.id) return;

            if (!state[medRequest.id]) {
                state[medRequest.id] = medRequest;
            } else {
                console.warn(
                    `⚠️ MedicationRequest ${medRequest.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterMedicationRequests: (state, action) => {
            action.payload.forEach((medRequest) => {
                if (!medRequest?.id) return;

                if (!state[medRequest.id]) {
                    state[medRequest.id] = medRequest;
                } else {
                    console.warn(
                        `⚠️ MedicationRequest ${medRequest.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const {
    registerMedicationRequest,
    bulkRegisterMedicationRequests
} = medicationRequestSlice.actions;

export default medicationRequestSlice.reducer;
